import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useSelector } from "react-redux";
import { PiCheckCircleBold } from "react-icons/pi";
import { IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import ThankyouIcon from "../../assets/images/OBJECTS.svg";
import { IoMdCloseCircleOutline } from "react-icons/io";

export default function FeedbackCompletedModal({}) {
  const navigate = useNavigate();
  const { showModal } = useSelector((state) => state.commonReducer);

  const handleClose = () => {
    // dispatch({
    //   type: commonActions.SET_SHOW_MODAL,
    //   payload: { show: false, type: null, method: null, data: null },
    // });
    Cookies.remove("test_engine_token");
    // Cookies.remove("test_engine_project");
    navigate(`/thank-you`);
  };

  return (
    <>
      <Dialog
        minWidth="sx"
        open={showModal?.show && showModal?.method === "B"}
        onClose={handleClose}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding:'24px'
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pb: 3,
          }}
        >
          <img src={ThankyouIcon} alt="Thank you" height={150} width={150}/>
            <Typography
              sx={{
                fontWeight: "bold",
                color: "rgba(63, 65, 209, 1)",
                fontSize: "26px",
                pt: 3,
              }}
            >
              Thankyou for submitting the Feedback
            </Typography>
        </DialogContent>
        <DialogActions style={{ display:"flex",justifyContent:"center",alignItems:"flex-start",paddingBottom:"15px" }}>
          <Button  onClick={handleClose} style={{color:"white",backgroundColor: "rgba(63, 65, 209, 1)",border:"1px solid rgba(63, 65, 209, 1)",borderRadius:"20px",width:"50%"}}>
                  Exit
                </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
